const cookieName = 'notification_blitz';

const getCurrentTime = () => {
	const nowDate = new Date();

	const options = {
		timeZone: 'Europe/Moscow',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
	};
	
	const day = nowDate.getDate();
	const month = nowDate.getMonth() + 1;
	const year = nowDate.getFullYear();

	const currentTime = nowDate.toLocaleString( 'ru-RU', options );

	return `${year}-${month}-${day} ${currentTime}`;
};

const closeNotification = ( blitz ) => {
	const domain = location.host.split( '.' ).slice( -1 ).join( '.' );

	const closeTime = getCurrentTime();

	if ( domain.includes( '.ru' ) )
	{
		document.cookie = `${cookieName}=${closeTime}; domain=${domain}; expires=${new Date( 2999, 5, 12 ).toUTCString()}; path=/`;
	}
	else
	{
		document.cookie = `${cookieName}=${closeTime}; expires=${new Date( 2999, 5, 12 ).toUTCString()}; path=/`;
	}

	blitz.classList.add( 'hidden' );
	blitz.remove();
	document.querySelector( 'header' ).style.marginTop = '0px';
	document.querySelector( 'body > main' ).style.marginTop = '0px';
};

const handleScroll = ( element ) => {
	const textWrapper = element.querySelector( 'p' );
	const linkWrapper = element.querySelector( 'a' );
	
	
	if ( !textWrapper && !linkWrapper )
	{
		return;
	}

	const scrollButton = element.querySelector('button.scroll');
	const span = textWrapper.querySelector('span');

	const text = linkWrapper || span;
	
	if (textWrapper.clientWidth < text.clientWidth) {
		scrollButton.classList.remove( "scroll-end" );
	}

	const checkScroll = () => {
		const scroll = textWrapper.scrollLeft / ( text.clientWidth - textWrapper.clientWidth );
		if ( isNaN(scroll) || scroll > 0.95 || scroll == Infinity ) {
			scrollButton.classList.add( "scroll-end" );
		}
		else {
			scrollButton.classList.remove( "scroll-end" );
		}
	}

	window.addEventListener('resize', () => {
		if (textWrapper.clientWidth >= text.clientWidth) {
			scrollButton.classList.add( "scroll-end" );
		} else {
			checkScroll();
		}
	})

	scrollButton.addEventListener('click', () => {
		textWrapper.scrollLeft += 200;
	})

	textWrapper?.addEventListener( 'scroll', () => {
		checkScroll();
	} );

	linkWrapper?.addEventListener( 'scroll', () => {
		if ( linkWrapper?.scrollLeft > 0 )
		{
			element.classList.add( 'no-ellipsis' );
		}
		else
		{
			element.classList.remove( 'no-ellipsis' );
		}
	} )
}

const initBlitz = () => {
	const blitz = document.querySelector( 'div.blitz' );

	if ( !blitz )
	{
		return;
	}

	handleScroll( blitz );

	blitz.classList.remove( 'hidden' );
	const closeBtn = blitz.querySelector( 'button.close' );

	closeBtn.addEventListener( 'click', () => closeNotification( blitz ) );
};

export {
	initBlitz,
};
